import { useEffect } from 'react'
import { NavLink, Link, Outlet, useLocation } from 'react-router-dom'
import { LoonMark } from './LoonMark'

const titles: Record<string, string> = {
  '/': 'Loonworks Software · websites that run Minnesota businesses',
  '/services': 'Services · Loonworks Software',
  '/work': 'Work · Loonworks Software',
  '/contact': 'Contact · Loonworks Software',
}

export function Layout() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = titles[pathname] ?? 'Loonworks Software'
  }, [pathname])

  return (
    <>
      <header className="site-header">
        <div className="wrap">
          <Link to="/" className="wordmark">
            <LoonMark />
            Loonworks
          </Link>
          <nav className="site-nav" aria-label="Site">
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/work">Work</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="wrap">
          <LoonMark />
          <p>
            Websites that run Minnesota businesses.
            <br />
            <Link to="/contact" style={{ color: 'inherit' }}>
              Tell me about yours
            </Link>
          </p>
          <p className="fine">© 2026 Loonworks Software LLC · Minnesota</p>
        </div>
      </footer>
    </>
  )
}
